<template>
  <v-dialog v-model="$parent.popup.isVisible" persistent width="800">
    <v-card>
      <v-toolbar class="trHeader" style="height: 40px;">
        <v-toolbar-title class="white--text" style="text-align:center;">{{$parent.popup.title}}</v-toolbar-title>
      </v-toolbar>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs6 style="border-left: 1px solid #eee;">
          <v-layout row wrap style="padding: 20px 10px 10px 10px;">
            <v-flex xs3 right style="text-align: right; padding-right: 10px">
              שם פרויקט
            </v-flex>
            <v-flex xs9>
              <input type="text" v-model="$parent.popup.data.Name" />
            </v-flex>
          </v-layout>
          <v-layout row wrap style="padding: 20px 10px 10px 10px;">
            <v-flex xs3 right style="text-align: right; padding-right: 10px">
              ישוב
            </v-flex>
            <v-flex xs9>
              <input type="text" v-model="$parent.popup.data.City" />
            </v-flex>
          </v-layout>
          <v-layout row wrap style="padding: 20px 10px 10px 10px;">
            <v-flex xs3 right style="text-align: right; padding-right: 10px">
              כתובת
            </v-flex>
            <v-flex xs9 style="position: relative;">
              <input type="text" v-model="$parent.popup.data.Address" style="background-color: yellow;" />
              <!--<gmap-autocomplete id="gmapAddress" v-model="$parent.popup.data.Address" @place_changed="setAddress" class="mapSearch"></gmap-autocomplete>-->
            </v-flex>
          </v-layout>
          <v-layout row wrap style="padding: 20px 10px 10px 10px;">
            <v-flex xs3 right style="text-align: right; padding-right: 10px">
              תיאור פרויקט
            </v-flex>
            <v-flex xs9>
              <textarea type="text" rows="3" v-model="$parent.popup.data.Info" style="width: 200px;" />
            </v-flex>
          </v-layout>
          <v-layout row wrap style="padding: 20px 10px 10px 10px;">
            <v-flex xs3 right>
              יזם
            </v-flex>
            <v-flex xs9 v-if="$parent.popup.data.Entrepreneur.UserKey">
              <div style="border: 1px solid #ddd; margin: 10px 40px 10px 40px; padding: 5px; text-align: right">
                {{$parent.popup.data.Entrepreneur.FullName}}
                <v-icon style="float: left;" @click="removeEntrepreneur()" v-tooltip:right="{ html: 'מחיקה' }">delete</v-icon>
              </div>
              <!--<v-layout style="border: 1px solid #ddd; margin: 10px 0px 10px 40px; padding-right: 20px;">
                <v-flex xs10>
                  {{$parent.popup.data.Entrepreneur.FullName}}
                </v-flex>
                <v-flex xs2>
                  <v-icon @click="removeEntrepreneur()" v-tooltip:right="{ html: 'מחיקה' }">delete</v-icon>
                </v-flex>
              </v-layout>-->
            </v-flex>
            <v-flex xs9 v-else>
              <input type="text" v-model="txtSearchEntrepreneur" style="width: 200px;" placeholder="חפש יזם" />
              <div v-if="filteredEntrepreneurs.length" class="custom-dropdown__select custom-dropdown__select--white" style="border: 1px solid #ccc; padding: 10px; margin-right: 45px; max-height: 150px; overflow-y: scroll; overflow-x: hidden;">
                <v-layout row wrap v-for="item in filteredEntrepreneurs" class="divAddedUser">
                  <v-flex xs12 right style="text-align: right;" @click="selectEntrepreneur(item)">{{item.FullName}}</v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap style="padding: 20px 10px 10px 10px;">
            <v-flex xs3 right style="text-align: right; padding-right: 10px">
              שלב התקדמות
            </v-flex>
            <v-flex xs9 style="padding-right: 50px;">
              <div class="divColorIcon" :style="{ 'background-color': selectedColor }"></div>
              <span class="custom-dropdown custom-dropdown--white" style="width: 170px; float: right;">
                <select v-model="$parent.popup.data.StatusKey" class="custom-dropdown__select custom-dropdown__select--white" style="width: 168px;">
                  <option value="">בחר שלב</option>
                  <option v-for="status in $parent.statuses" :value="status['.key']">{{status.Name}}</option>
                </select>
              </span>
            </v-flex>
          </v-layout>
          <!--<v-layout row wrap style="padding: 20px 10px 10px 10px;">
            <v-flex xs3 right>
            </v-flex>
            <v-flex xs4>
              <input type="checkbox" v-model="$parent.popup.data.Active" class="w3-check"> פעיל
            </v-flex>
            <v-flex xs3>
            </v-flex>
          </v-layout>-->
          <v-layout row wrap style="padding: 20px 10px 10px 10px;">
            <v-flex xs3 right style="text-align: right; padding-right: 10px">
              תאריך התחלה
            </v-flex>
            <v-flex xs3 style="text-align: left;padding-left: 50px;">
              <input type="date" v-model="$parent.popup.data.StartDate" style="width: 100px;" />
            </v-flex>
          <!--</v-layout>
          <v-layout row wrap style="padding: 20px 10px 10px 10px;">-->
            <v-flex xs3 right style="text-align: right; padding-right: 10px">
              תאריך סיום
            </v-flex>
            <v-flex xs3 style="text-align: left;padding-left: 50px;">
              <input type="date" v-model="$parent.popup.data.EndDate" :min="startDate" style="width: 100px;" />
            </v-flex>
          </v-layout>
          <v-flex row wrap style="padding: 10px 10px 10px 10px;">
            <span class="error" v-show="error">* {{error}}</span>
          </v-flex>
        </v-flex>
        <v-flex xs6>
          <v-flex style="height: 75%; position: relative;">
            <img v-if="hasImages" class="imgPreview" :src="activeImage"/>
            <img v-else class="imgPreview" src="../assets/no_image.png" />
            <v-icon v-if="hasImages" @click="removeImage" class="btnIcon mr-2 btnRemoveImage" v-tooltip:bottom="{ html: 'מחיקה' }">close</v-icon>
          </v-flex>
          <v-flex style="text-align: right;">
            <img v-for="img in $parent.popup.data.Images" :class="['imgThumb', activeImage==img?'active':'']" :src="img" @click="activeImage=img" />
          </v-flex>
          <v-flex style="vertical-align: bottom; text-align: right;">
            <label class="file-select" >
              העלאת תמונה
              <v-icon v-show="!showProgress" right class="green--text" v-tooltip:bottom="{ html: 'העלאת תמונה' }">cloud_upload</v-icon>
              <v-progress-circular v-show="showProgress" indeterminate color="primary"></v-progress-circular>
              <input type="file" @change="upload" />
            </label>
          </v-flex>
        </v-flex>
      </v-layout>
      <hr />
      <v-flex v-if="canEdit" actions style="padding-bottom: 20px;">
        <v-btn outline small class="green green--text ml-3" @click.native="save">
          שמירה
          <v-icon left>check</v-icon>
        </v-btn>
        <v-btn outline small class="red red--text ml-2" @click.native="cancel">
          ביטול
          <v-icon left>block</v-icon>
        </v-btn>
      </v-flex>
      <v-flex v-else actions style="padding-bottom: 20px;">
        <v-btn outline small class="red red--text ml-2" @click.native="cancel">
          סגור חלון
          <v-icon left>cancel</v-icon>
        </v-btn>
      </v-flex>
    </v-card>
  </v-dialog>
</template>

<script>
  import Datepicker from 'vuejs-datepicker';
  import noImg from '../assets/no_image.png';

  import { db, storage } from '../firebase';
  var projectsRef = db.ref('Projects');
  var usersRef = db.ref('Users');

  export default {
    name: 'PopupProject',
    components: { Datepicker },
    data() {
      return {
        txtSearchEntrepreneur: '',
        entrepreneurs: [],
        error: '',
        selectedColor: '#ffffff',
        showFile: false,
        showProgress: false,
        logoUrl: '',
        activeImage: noImg,
        startDate: '',
        endDate: '',
      }
    },
    firebase: function () {
      return {
        entrepreneurs: usersRef.orderByChild("Type").equalTo("יזם")
      }
    },
    created() {
      this.$Log("Vue [PopupProject] is created ...");
    },
    ready() {
      this.$Log("Vue [PopupProject] is ready ...");
    },
    mounted() {
      this.$Log("Vue [PopupProject] is mounted ...");
    },
    updated() {
      this.$Log("Vue [PopupProject] is updated ...");
      var vm = this;
      if (this.$parent.statuses != null) {
        for (var i = 0; i < this.$parent.statuses.length; i++) {
          if (this.$parent.statuses[i]['.key'] == this.$parent.popup.data.StatusKey) {
            this.selectedColor = this.$parent.statuses[i].Color;
            break;
          }
        }
      }

      if (vm.$parent.popup.data.Address == '') {
        vm.$GetPlaceName(vm.$parent.popup.data.Location, function (placeName) {
          console.log(JSON.stringify(placeName));
          if (placeName.success) {
            vm.$parent.popup.data.Address = placeName.data.formatted_address;
            vm.$parent.popup.data.Address = vm.$parent.popup.data.Address.replace("Unnamed Road,", "");
          }
          else {
            vm.$parent.popup.data.Address = '';
            var gmapAddress = document.getElementById("gmapAddress").value = '';
            if (gmapAddress) {
              gmapAddress.value = '';
            }
          }
        });
      }
      //$parent.popup.data.Location

      if (this.$parent.popup.data.Images == undefined) {
        this.$parent.popup.data.Images = [];
        this.activeImage = noImg;
      }
      else {
        if (this.$parent.popup.data.Images.length > 0) {
          if (this.activeImage == noImg) {
            this.activeImage = this.$parent.popup.data.Images[0];
          }
        }
      }
      
      //if (this.$parent.popup.data.StartDate) {
      //  this.startDate = this.$moment(this.$parent.popup.data.StartDate, 'DD/MM/YYYY').format("YYYY-MM-DD");
      //}
      //else {
      //  this.startDate = this.$moment().format("YYYY-MM-DD");
      //}

      //if (this.$parent.popup.data.EndDate) {
      //  this.endDate = this.$moment(this.$parent.popup.data.EndDate, 'DD/MM/YYYY').format("YYYY-MM-DD");
      //}
      //else {
      //  this.endDate = this.$moment().format("YYYY-MM-DD");
      //}
    },
    computed: {
      canEdit() {
        return true;
      },
      hasImages() {
        if (this.$parent.popup.data.Images != undefined && this.$parent.popup.data.Images.length > 0) {
          return true;
        }
        else {
          return false;
        }
      },
      filteredEntrepreneurs() {
        var vm = this;
        var result = [];

        if (vm.txtSearchEntrepreneur.length > 0) {
          var result = [];
          try {
            result = vm.entrepreneurs.filter(function (row) {
              return (row.FullName.trim().toLowerCase().indexOf(vm.txtSearchEntrepreneur.trim().toLowerCase()) > -1);
            }).slice(0, 5);
          }
          catch (e) {
            result = [];
          }
        }
        else {
          result = [];
        }

        return result;
      }
    },
    methods: {
      selectEntrepreneur(item) {
        this.txtSearchEntrepreneur = "";
        this.$parent.popup.data.Entrepreneur = { UserKey: item['.key'], FullName: item.FullName };
      },
      removeEntrepreneur() {
        this.txtSearchEntrepreneur = "";
        this.$parent.popup.data.Entrepreneur = { UserKey: '', FullName: '' };
      },
      setAddress(place) {
        this.$Log("setPlace(place) >>> " + JSON.stringify(place));
        this.$parent.popup.data.Location = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
      },
      isValid(callback) {
        console.log(JSON.stringify(this.$parent.popup.data))
        if (this.$parent.popup.data.Name.trim().length <= 0) { this.$Log("Missing Name !"); return false; }
        if (this.$parent.popup.data.City.trim().length <= 0) { this.$Log("Missing City !"); return false; }
        if (this.$parent.popup.data.Address.trim().length <= 0) { this.$Log("Missing Address !"); return false; }
        if (this.$parent.popup.data.Info.trim().length <= 0) { this.$Log("Missing Info !"); return false; }
        if (this.$parent.popup.data.StatusKey.trim().length <= 0) { this.$Log("Missing StatusKey !"); return false; }
        if (this.$parent.popup.data.Location.lat == 0) { this.$Log("Missing Location.lat !"); return false; }
        if (this.$parent.popup.data.Location.lng == 0) { this.$Log("Missing Location.lng !"); return false; }
        if (this.$parent.popup.data.StartDate == undefined || this.$parent.popup.data.StartDate <= 0) { this.$Log("Missing StartDate !"); return false; }
        if (this.$parent.popup.data.EndDate == undefined || this.$parent.popup.data.EndDate <= 0) { this.$Log("Missing EndDate !"); return false; }

        return true;
      },
      save() {
        var vm = this;
        vm.error = "";
        // Set defualt Locatione:
        vm.$parent.popup.data.Location = { lat: 32.699635, lng: 35.303546 }
        console.log(vm.$parent.popup.data)
        var valid = vm.isValid();
        if (valid == true) {
          if (vm.$parent.popup.isEdit) {
            console.log(vm.$parent)
            vm.$parent.update();
          }
          else {
            vm.$parent.insert();
          }
          vm.reset();
        }
        else if (valid == "NO_USER") {
          vm.error = "שם משתמש לא קיים !"
        }
        else {
          vm.error = "נא למלא את כל השדות!"
        }
      },
      cancel() {
        this.reset();
      },
      reset() {
        this.error = "";
        this.$parent.popup = {
          isVisible: false,
          isEdit: false,
          title: '',
          data: {
            '.key': '',
            Name: '',
            City: '',
            Address: '',
            Location: { lat: 0, lng: 0 },
            Info: '',
            StatusKey: 0,
            UserKey: '',
            Active: true,
            Images: [],
            CreateDate: '',
            UpdateDate: '',
            StartDate: '',
            EndDate: '',
            Entrepreneur: { UserKey: '', FullName: '' }
          }
        };
        this.activeImage = noImg;
      },
      upload(e) {
        this.$emit('#fileUpload', e.target.files[0]);
        var files = e.target.files || e.dataTransfer.files;

        if (!files.length) return;

        var vm = this;

        var file = files[0];
        var image = new Image();
        var reader = new FileReader();

        reader.onload = (ev) => {
          vm.logoUrl = ev.target.result;
        };
        reader.readAsDataURL(file);

        vm.showFile = true;

        var storageRef = storage.ref('images/' + file.name);

        var task = storageRef.put(file);

        vm.showProgress = true;

        task.on('state_changed',
          function progress(snap) {
            //vm.percent = (snap.bytesTransferred / snap.totalBytes) * 100;
          },
          function error(err) {
            vm.showFile = false;
            vm.showProgress = false;
          },
          function complete() {
            vm.showProgress = false;
            vm.logoUrl = task.snapshot.downloadURL;
            vm.$parent.popup.data.Images.push(task.snapshot.downloadURL);
            if (vm.activeImage == noImg) {
              vm.activeImage = vm.$parent.popup.data.Images[0];
            }
          }
        );
      },
      removeImage() {

      }
    }
  }

</script>
<style>
  .error {
    color: red;
    background-color: #fff !important;
  }

  .divColorIcon {
    width: 30px;
    height: 30px;
    float: right;
    border: 1px solid #000;
    background-color: #fff;
  }

  .mapSearch {
    opacity: 1;
    position: absolute;
    top: 0px;
    right: 18%;
    /*z-index: 16100 !important;*/
    z-index: 10000 !important;
    width: 62%;
    border: none;
    background-color: white;
    /*height: 40px;
    line-height: 40px;*/
    padding-left: 10px;
    color: #3A2D01;
    font-size: 13px;
  }
  .pac-container {
    z-index: 110000 !important;
  }

  .file-select {
    padding-right: 5px;
    cursor: pointer;
  }

    .file-select > .select-button {
      padding: 1rem;
      color: white;
      background-color: #2EA169;
      border-radius: .3rem;
      text-align: center;
      font-weight: bold;
    }

    .file-select > input[type="file"] {
      display: none;
    }

  .fileUpload {
    display: none;
  }

  .imgPreview {
    border: 1px solid #3A2D01;
    border-radius: 3px;
    padding: 2px;
    margin: 2px;
    width: 85%;
    max-height: 300px;
  }

  .imgThumb {
    height: 50px;
    border: 1px solid #3A2D01;
    border: 1px solid #fff;
    border-radius: 10px;
    padding: 1px;
    margin: 1px;
  }

    .active {
      border-color: #F7941D !important;
    }

  .btnRemoveImage {
    position: absolute;
    top: 10px;
    left: 40px;
    background-color: #fff;
    border-radius: 50%;
  }

</style>



// WEBPACK FOOTER //
// PopupProject.vue?2f5078c2